var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg14(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.5,
    height: 43.888,
    viewBox: "0 0 64.5 43.888",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Komponente_10_53",
    "data-name": "Komponente 10 \\u2013 53",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "heart",
    transform: "translate(-2.9 -18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46730",
    "data-name": "Pfad 46730",
    d: "M60.04,40.236a12.664,12.664,0,0,0,3.593-8.949A13.547,13.547,0,0,0,49.871,18a13.841,13.841,0,0,0-12.338,7.389,13.883,13.883,0,0,0-12.271-7.322A13.547,13.547,0,0,0,11.5,31.355a12.736,12.736,0,0,0,3.525,8.881c5.22,5.288,21.694,20.745,21.829,20.88a.971.971,0,0,0,.678.271.87.87,0,0,0,.678-.271c.136-.068,16.542-15.525,21.829-20.88ZM37.533,59.083C34.346,56.1,21.059,43.558,16.449,38.88a10.561,10.561,0,0,1-2.983-7.457A11.552,11.552,0,0,1,25.194,20.169a11.616,11.616,0,0,1,11.321,8.339,1.087,1.087,0,0,0,.949.746.956.956,0,0,0,.949-.746A11.675,11.675,0,0,1,49.735,20.1,11.465,11.465,0,0,1,61.464,31.355a10.561,10.561,0,0,1-2.983,7.457C53.939,43.49,40.719,56.032,37.533,59.083Z",
    transform: "translate(-2.77)",
    fill: "#a5b5af",
    stroke: "#a5b5af",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46731",
    "data-name": "Pfad 46731",
    d: "M8.391,48.7a13.056,13.056,0,0,1-3.457-9.084A1.043,1.043,0,0,0,3.917,38.6,1.043,1.043,0,0,0,2.9,39.617,15.105,15.105,0,0,0,6.968,50.125c1.152,1.22,2.847,2.915,5.084,5.152a1.161,1.161,0,0,0,1.491,0,.983.983,0,0,0,0-1.424C11.239,51.616,9.544,49.921,8.391,48.7Z",
    transform: "translate(0 -6.635)",
    fill: "#a5b5af",
    stroke: "#a5b5af",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46732",
    "data-name": "Pfad 46732",
    d: "M92.219,23.6a1.025,1.025,0,0,0-1.695,1.152,13.984,13.984,0,0,1,2.508,8,14.179,14.179,0,0,1-1.559,6.508,1.009,1.009,0,0,0,.407,1.356,1.257,1.257,0,0,0,.475.136.977.977,0,0,0,.881-.542,15.569,15.569,0,0,0,1.83-7.457A15.121,15.121,0,0,0,92.219,23.6Z",
    transform: "translate(-28.17 -1.664)",
    fill: "#a5b5af",
    stroke: "#a5b5af",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46733",
    "data-name": "Pfad 46733",
    d: "M80.5,55.955c-2.508,2.576-6.169,6.237-10.847,10.847a.983.983,0,0,0,0,1.424,1.161,1.161,0,0,0,1.491,0c4.678-4.61,8.339-8.271,10.847-10.847a.983.983,0,0,0,0-1.424A1.063,1.063,0,0,0,80.5,55.955Z",
    transform: "translate(-21.401 -12.126)",
    fill: "#a5b5af",
    stroke: "#a5b5af",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46734",
    "data-name": "Pfad 46734",
    d: "M23.637,29.355a.983.983,0,0,0-1.424,0,8.486,8.486,0,0,0,0,11.593,1.089,1.089,0,0,0,.746.339.786.786,0,0,0,.678-.271.983.983,0,0,0,0-1.424,6.394,6.394,0,0,1,0-8.745,1.064,1.064,0,0,0,0-1.491Z",
    transform: "translate(-5.483 -3.559)",
    fill: "#a5b5af",
    stroke: "#a5b5af",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg14);
export default __webpack_public_path__ + "static/media/14.557b31a7726fecaa3eb2618943794650.svg";
export { ForwardRef as ReactComponent };